import { render } from "./MandatoryCoursesView.vue?vue&type=template&id=1634d946"
import script from "./MandatoryCoursesView.vue?vue&type=script&lang=js"
export * from "./MandatoryCoursesView.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__